import { render, staticRenderFns } from "./IvrPushLog.vue?vue&type=template&id=6960e52b&scoped=true"
import script from "./IvrPushLog.vue?vue&type=script&lang=js"
export * from "./IvrPushLog.vue?vue&type=script&lang=js"
import style0 from "./IvrPushLog.vue?vue&type=style&index=0&id=6960e52b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6960e52b",
  null
  
)

export default component.exports